import { gql } from "@apollo/client";

const UPDATE_LOCATION = gql`
  mutation updateLocation($id: ID!, $location: LocationUpdateInput!, $users: [ID]) {
    updateLocation(id: $id, location: $location, users: $users) {
      success
      message
      location {
        id
      }
    }
  }
`;

const ADD_HOLIDAY = gql`
  mutation addHoliday($id: ID!, $holiday: HolidayInput!) {
    addedHoliday(id: $id, holiday: $holiday) {
      success
      message
      location {
        id
      }
    }
  }
`;

const DELETE_HOLIDAY = gql`
  mutation deleteHoliday($id: ID!, $date: Date!) {
    deleteHoliday(id: $id, date: $date) {
      success
      message
      location {
        id
      }
    }
  }
`;

export { UPDATE_LOCATION, ADD_HOLIDAY, DELETE_HOLIDAY };
